<template>
  <div class="atom-progress-bar_graph">
    <label v-if="title" class="graph__label">{{ title }}</label>
    <label v-if="subTitle" class="graph__label">: {{ subTitle }}</label>
    <v-chart
      class="graph__echarts"
      autoresize
      :option="option"
      ref="bar"
      auto-resize
    />
  </div>
</template>

<script>
import { use } from "echarts/core"

// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from "echarts/renderers"
import { BarChart } from "echarts/charts"
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components"
import VChart from "vue-echarts"

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  name: "AtomProgressBar",
  components: { VChart },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "primary",
      // value = [ "primary", "warning", "danger"]
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data() {
    return {
      option: {},
    }
  },
  watch:{
    value:{
      deep:true,
      handler(){
        this.initialEcharts()
      }
    }
  },
  computed: {
    barColor() {
      if (this.color === "primary") return "#7367F0"
      if (this.color === "danger") return "#EA5455"
      if (this.color === "success") return "#28C76F"
      if (this.color === "secondary") return "#82868B"
      if (this.color === "warning") return "#FF9F43"
      return this.color
    },
    bgBarColor() {
      if (this.color === "primary") return "#EEEDFD"
      if (this.color === "danger") return "#FCEAEB"
      if (this.color === "success") return "#E5F8EE"
      if (this.color === "secondary") return "#F0F1F1"
      if (this.color === "warning") return "#FFF3E8"
      if (this.color === "info") return "#E0F9FC"
      return this.color
    },
  },
  mounted() {
    this.initialEcharts()
  },
  methods: {
    initialEcharts() {
      this.option = {
        grid: {
          top: "0%",
          left: "0%",
          right: "0%",
          bottom: "0%",
        },
        xAxis: {
          type: "value",
          max: this.max,
          show: false,
        },
        yAxis: {
          type: "category",
          data: ["Key"],
          show: false,
        },
        series: [
          {
            silent: true,
            data: [this.value],
            type: "bar",
            showBackground: true,
            barWidth: "100%",
            barMinHeight: "100%",
            backgroundStyle: {
              color: this.bgBarColor,
              borderRadius: 6,
            },
            itemStyle: {
              borderRadius: 6,
              color: this.barColor,
            },
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// graph
.atom-progress-bar_graph {
  width: 100%;
}
.graph__label {
  color: #6e6b7b;
  font-size: 14px;
}
.graph__echarts {
  height: 8px;
}
</style>
